"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useParams } from "next/navigation";
import { useEffect } from "react";
import { logger } from "@/lib/services/logger";
import { useAuthStore } from "@/lib/stores/authStore";
export function useSentryTenantContext() {
  const $ = _c(10);
  const user = useAuthStore(_temp);
  const {
    workspaceId
  } = useParams() as {
    workspaceId?: string;
  };
  let t0;
  if ($[0] !== workspaceId) {
    t0 = workspaceId?.trim() || undefined;
    $[0] = workspaceId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resolvedWorkspaceId = t0;
  let t1;
  if ($[2] !== resolvedWorkspaceId || $[3] !== user) {
    t1 = function syncSentryTenantContext() {
      if (!user?.id) {
        logger.setUser(null);
        logger.setTenantTag("organizationId", undefined);
        logger.setTenantTag("workspaceId", undefined);
        logger.setContext("tenant", null);
        return;
      }
      logger.setUser({
        id: user.id
      });
      logger.setTenantTag("organizationId", user.organizationId || undefined);
      logger.setTenantTag("workspaceId", resolvedWorkspaceId);
      logger.setContext("tenant", {
        organizationId: user.organizationId,
        role: user.role,
        workspaceId: resolvedWorkspaceId
      });
    };
    $[2] = resolvedWorkspaceId;
    $[3] = user;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = user?.id;
  const t3 = user?.organizationId;
  const t4 = user?.role;
  let t5;
  if ($[5] !== resolvedWorkspaceId || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = [resolvedWorkspaceId, t2, t3, t4];
    $[5] = resolvedWorkspaceId;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t1, t5);
}
function _temp(state) {
  return state.user;
}